import {clearA360CommissionsState} from 'Agent/Commissions/ducks/a360Commissions';
import React, {useEffect} from 'react';
import {useDispatch, useSelector} from 'react-redux';
import {ReducerState} from 'rootReducer';
import {A360CommissionFilters} from './CommissionFilters';
import {A360CommissionStatements} from './CommissionStatements';
import './Commissions.scss';
import {AdjustmentDetails} from './AdjustmentDetails';
import {CommissionPayable} from './CommissionPayable';
import {CommissionSummaryView} from './CommissionSummaryView';
import {PaymentReceipts} from './PaymentReceipts';

export const A360CommissionsDashboard = () => {
  const {filter} = useSelector((state: ReducerState) => state.a360Commissions);

  const dispatch = useDispatch();

  useEffect(() => {
    return () => {
      dispatch(clearA360CommissionsState());
    };
  }, []);

  return (
    <main className="a360-commissions__dashboard-grid">
      <A360CommissionFilters />
      {filter.selectedProducerCodes.length > 0 &&
        filter.selectedStatementDates.length > 0 &&
        filter.selectedEmployerNames.length > 0 && (
          <>
            <CommissionPayable />
            <CommissionSummaryView />
            <PaymentReceipts />
            <AdjustmentDetails />
            <A360CommissionStatements />
          </>
        )}
    </main>
  );
};
